import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SampleProducts } from "../data/sampleProducts";
import "./searchProductos.css";

export default function SearchProductos() {
  
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("Todos");
  const [brandFilter, setBrandFilter] = useState("Todos");

  const filteredProducts = SampleProducts.filter((product) => {
    const matchSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchCategory = categoryFilter === "Todos" || product.category === categoryFilter;
    const matchBrand = brandFilter === "Todos" || product.brand === brandFilter;
    return matchSearch && matchCategory && matchBrand;
  });

  const categories = ["Todos", ...new Set(SampleProducts.map((p) => p.category))];
  const brands = ["Todos", ...new Set(SampleProducts.map((p) => p.brand))];

  return (
    <div className="product-search-container">
      <h2 className="product-title">Productos</h2>

      <div className="filters-container">
        <label htmlFor="search-input" className="sr-only">
          Buscar producto:
        </label>
        <input
          type="text"
          id="search-input"
          placeholder="Buscar producto..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <label htmlFor="filtro-categorias" className="sr-only">
          Filtrar por categoría:
        </label>
        <select
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
          className="filter-select"
          id="filtro-categorias"
        >
          {categories.map((cat, i) => (
            <option key={i} value={cat}>
              {cat}
            </option>
          ))}
        </select>
        
        <label htmlFor="filtro-marcas" className="sr-only">
          Filtrar por marca:
        </label>
        <select
          value={brandFilter}
          onChange={(e) => setBrandFilter(e.target.value)}
          className="filter-select"
          id="filtro-marcas"
        >
          {brands.map((brand, i) => (
            <option key={i} value={brand}>
              {brand}
            </option>
          ))}
        </select>
      </div>

      <div className="product-grid">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <div 
              key={product.id} 
              className="product-card"
              onClick={() => navigate(`/producto/${product.id}`)}
            >
              <img src={product.image} alt={product.name} className="product-image" />
              <h3 className="product-name">{product.name}</h3>
              <p className="product-brand">{product.brand}</p>
            </div>
          ))
        ) : (
          <p className="no-results">No se encontraron productos.</p>
        )}
      </div>
    </div>
  );
}
